import MicroModalAdaptor from "../core/components/microModalAdpt/index.js";

export default {
  listen() {
    window.addEventListener("load", () => {
      // get current route from window.location
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      // check if a query named notAllowed is present
      if (params.not_allowed) {
        // Creates trigger temporarily to fulfill MicroModalAdaptor's requirements
        const button = document.createElement("button");
        button.dataset.compModalTrigger = "not-allowed";
        document.body.appendChild(button);

        // open modal with warning
        const modal = new MicroModalAdaptor(button);
        modal.show();

        button.parentNode.removeChild(button);
      }
    });
  },
};
